import { makeAutoObservable } from 'mobx';

export interface ISinglePatientStore {
  isLoading: boolean;
  setIsLoading(value: boolean): void;
}

export default class SinglePatientStore implements ISinglePatientStore {
  isLoading = false;

  constructor() {
    makeAutoObservable(this);
  }

  setIsLoading(value: boolean) {
    this.isLoading = value;
  }
}
